import { render, staticRenderFns } from "./ProfilePageName.vue?vue&type=template&id=6682c2ec&"
import script from "./ProfilePageName.vue?vue&type=script&lang=js&"
export * from "./ProfilePageName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports